import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";

function CreaInvestigaciones(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(false);

  const mostrarResultado = (data, esErrorForzado = false) => {
    let html = `<div style="text-align:left; max-height:400px; overflow-y:auto;">`;
    let esError = esErrorForzado;

    if (typeof data === "string") {
      html += `<p><strong>${data}</strong></p>`;
      esError = true;
    } else if (Array.isArray(data)) {
      html += `<p><strong>Proceso ejecutado correctamente</strong></p>`;
      html += `<p><b>Registros creados:</b> ${data.length}</p>`;
    } else if (typeof data === "object" && data !== null) {
      html += `<p><strong>${data.mensaje || "Resultado del proceso"}</strong></p>`;

      if (data.registrosTotales !== undefined) {
        html += `<p><b>Registros Totales:</b> ${data.registrosTotales}</p>`;
      }

      if (data.registrosCargados !== undefined) {
        html += `<p><b>Registros Cargados:</b> ${data.registrosCargados}</p>`;
      }

      if (data.errores?.length) {
        esError = true;
        html += `<hr/><b>Errores (${data.errores.length}):</b><ul>`;
        data.errores.forEach((error) => {
          html += `<li>${error}</li>`;
        });
        html += `</ul>`;
      }

      if (data.registrosCargados === 0 && data.registrosTotales > 0) {
        esError = true;
      }
    }

    html += `</div>`;

    Swal.fire({
      icon: esError ? "error" : "success",
      title: esError ? "Proceso con errores" : "Proceso exitoso",
      html,
      width: 700,
    });

    return !esError;
  };

  const insertarArchivos = async () => {
    if (!archivos?.length) {
      return Swal.fire(
        "Atención",
        "Debe seleccionar al menos un archivo",
        "warning",
      );
    }

    setLoading(true);

    try {
      const formData = new FormData();
      Array.from(archivos).forEach((file) => {
        formData.append("files", file);
      });

      const { data } = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CreaInvestigaciones?SolicitudId=${props.idSolicitud}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const fueExitoso = mostrarResultado(data);

      if (fueExitoso) {
        setIsOpen(false);
        setArchivos([]);
        props.onRegistroCreado?.(data);
      }
    } catch (error) {
      mostrarResultado(
        error.response?.data || "Error inesperado al cargar los archivos",
        true,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Adjuntar Documento
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Cargar Investigaciones (XLSX)
            </h6>
          </div>

          <div className="card-body text-center">
            <input
              type="file"
              accept=".xlsx"
              multiple
              onChange={(e) => setArchivos(e.target.files)}
            />

            <hr />

            <button
              className="btn btn-primary"
              onClick={insertarArchivos}
              disabled={loading}
            >
              {loading ? "Subiendo..." : "Insertar archivos"}
            </button>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaInvestigaciones;
